module.exports = __webpack_public_path__ + "static/media/modis2903.eb83d560.jpg";